import z from 'zod';
export const projectTableFields = {
    id: 'string',
    name: 'string',
    llc_name: 'string',
    geo: 'string',
    rto_non_rto_region: 'string',
    stage: 'string',
    cod: 'date',
    plant_type: 'string',
    expected_poi_capacity: 'number',
    total_planned_capacity_mw_ac: 'number',
    pv_ac_design_capacity: 'number',
    li_ion_storage_capacity_mwh_ac: 'number',
    li_ion_power_mw_ac: 'number',
    wind_capacity_mw_ac: 'number',
    lead_developer: 'string',
    eng_lead: 'string',
    finance_lead: 'string',
    land_lead: 'string',
    permit_lead: 'string',
    origination_lead: 'string',
    txm_planner: 'string',
    archived: 'boolean',
};
export const projectTableOperators = {
    string: [
        'contains',
        'doesNotContain',
        'equals',
        'doesNotEqual',
        'startsWith',
        'endsWith',
        'isEmpty',
        'isNotEmpty',
        'isAnyOf',
    ],
    number: ['=', '!=', '>', '>=', '<', '<=', 'isEmpty', 'isNotEmpty', 'isAnyOf'],
    date: ['is', 'not', 'after', 'onOrAfter', 'before', 'onOrBefore', 'isEmpty', 'isNotEmpty'],
    boolean: ['is'],
};
const fieldSchema = z.enum(Object.keys(projectTableFields));
const filterValueSchemas = {
    string: z.string().min(1),
    number: z.union([z.number(), z.string().trim().min(1).transform(Number)]).pipe(z.number()),
    date: z.iso.date(),
    boolean: z.union([z.boolean(), z.enum(['true', 'false'])]),
};
const filterSchema = z
    .object({
    field: fieldSchema,
    operator: z.string(),
    value: z
        .union([z.string(), z.number(), z.boolean(), z.array(z.union([z.string(), z.number()]))])
        .optional(),
})
    .superRefine((filter, ctx) => {
    const kind = projectTableFields[filter.field];
    if (!projectTableOperators[kind].includes(filter.operator)) {
        ctx.addIssue({ code: 'custom', message: 'Unsupported project filter operator' });
    }
    if (['isEmpty', 'isNotEmpty'].includes(filter.operator))
        return;
    const values = Array.isArray(filter.value) ? filter.value : [filter.value];
    if (filter.operator === 'isAnyOf' &&
        (!Array.isArray(filter.value) || filter.value.length === 0)) {
        ctx.addIssue({ code: 'custom', message: 'isAnyOf requires an array' });
    }
    if (filter.operator !== 'isAnyOf' && Array.isArray(filter.value)) {
        ctx.addIssue({ code: 'custom', message: 'Filter requires a scalar value' });
    }
    if (values.some((value) => !filterValueSchemas[kind].safeParse(value).success)) {
        ctx.addIssue({ code: 'custom', message: 'Invalid project filter value' });
    }
});
export const projectTableQuerySchema = z.object({
    sort: z
        .array(z.object({ field: fieldSchema, sort: z.enum(['asc', 'desc']) }))
        .max(22)
        .default([]),
    filters: z.array(filterSchema).max(50).default([]),
    logic: z.enum(['and', 'or']).default('and'),
});
//# sourceMappingURL=project-table.js.map